import React from "react";
import { AnimatePresence, motion } from "framer-motion";

interface FloatingActionProps {
  visible: boolean;
  items?: React.ReactNode[];
}

export function FloatingAction({
  visible,
  items,
}: Readonly<FloatingActionProps>) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="bg-background fixed bottom-8 left-1/2 z-50 flex -translate-x-1/2 items-center gap-2 rounded-md border-2 border-indigo-400/80 px-4 py-2 shadow-lg ring-1 ring-indigo-300/60"
        >
          {items?.map((item, idx) => <div key={idx}>{item}</div>)}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
